import * as rpcSetup from "@agrigate/reporting-ui/lib/rpc";
import rpc, { getHeaders, handleError } from "../utils/rpc";

rpcSetup.getHeaders.override(() => getHeaders);
rpcSetup.handleError.override(() => handleError);
rpcSetup.getLocationService.override(() => () => rpc.location);
